/* ASA Glass v2 (2026-10-21)
   1. Phones: the header slides away while scrolling down and comes back when scrolling up.
   2. Phone tab bar: a jelly glass lens. It always sits on the tab of the current page, follows the finger
      while dragging along the bar (stretching with speed), and springs onto the tab it is released on
      (that tab then opens). Tapping the tab you are on scrolls back to the top.
      Strong haptics: Android vibrates on every tab passed while dragging, on release and on taps;
      iPhone gives its system tick on taps (Safari allows no vibration from scripts or during swipes).
   Nothing here runs or measures while the page loads except one measurement of the bar. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. hide-on-scroll header (phones) ---------- */
  var phone = window.matchMedia('(max-width: 749px)');
  var lastY = window.scrollY || 0;
  var acc = 0;
  var hidden = false;
  var ticking = false;
  var hdrH = 140;
  function blocked() {
    return doc.classList.contains('asa-shop-open') ||
      !!document.querySelector('.menu-drawer[open], details.menu-drawer-container[open], dialog[open], #search-modal[open]');
  }
  function setHidden(h) {
    if (h === hidden) return;
    hidden = h;
    doc.classList.toggle('asa-hdr-hide', h);
  }
  function onScroll() {
    ticking = false;
    var y = Math.max(0, window.scrollY || 0);
    var dy = y - lastY;
    lastY = y;
    if (!phone.matches || blocked()) { acc = 0; setHidden(false); return; }
    if (y < hdrH + 24) { acc = 0; setHidden(false); return; }
    if (dy > 0) {
      acc = acc < 0 ? dy : acc + dy;
      if (acc > 14) setHidden(true);
    } else if (dy < 0) {
      acc = acc > 0 ? dy : acc + dy;
      if (acc < -10) setHidden(false);
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  function measure() {
    var h = document.querySelector('#header-component');
    if (h) hdrH = h.offsetHeight || hdrH;
  }
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', function () { setTimeout(measure, 300); });
  /* focus moving into the header (keyboard) always shows it */
  document.addEventListener('focusin', function (e) {
    if (hidden && e.target.closest && e.target.closest('#header-component')) setHidden(false);
  });

  /* ---------- 2. tab bar lens ----------
     A small spring simulation drives one transform on the lens (GPU only, no layout), only while it moves.
     Position: damped spring towards the target (the finger while dragging, the tab after release).
     Jelly: the lens stretches along its speed and gets a little flatter; it grows while pressed. */
  function initLens(nav) {
    if (!nav || nav.__asaLens) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('.asa-bnav__item'));
    if (!items.length) return;
    nav.__asaLens = true;

    var lens = document.createElement('span');
    lens.className = 'asa-bnav__lens';
    lens.setAttribute('aria-hidden', 'true');
    nav.insertBefore(lens, nav.firstChild);

    var style = document.createElement('style');
    style.textContent = '@media screen and (max-width:749px){' +
      '.asa-bnav .asa-bnav__lens{transition:opacity .2s ease,background-color .25s ease,box-shadow .25s ease!important;transform-origin:50% 50%}' +
      '.asa-bnav.is-pressing .asa-bnav__lens{background:rgb(255 255 255 / .78);box-shadow:inset 0 1px 0 rgb(255 255 255 / .95),0 10px 22px -10px rgb(60 38 14 / .45)}' +
      'html[data-asa-mode=dark] .asa-bnav.is-pressing .asa-bnav__lens{background:rgb(255 255 255 / .2)}' +
      '.asa-bnav.is-pressing .asa-bnav__item.is-lens{transform:scale(1.1)}' +
      '.asa-bnav__item.is-lens{color:var(--asa-ink)}}';
    document.head.appendChild(style);

    /* links must not start a native drag or a long-press menu, or the browser takes the finger away */
    items.forEach(function (it) { it.setAttribute('draggable', 'false'); });
    nav.addEventListener('dragstart', function (e) { e.preventDefault(); });
    nav.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    /* ----- which tab belongs to this page ----- */
    function norm(p) { return (p || '/').replace(/\/+$/, '') || '/'; }
    function find(sel) { for (var i = 0; i < items.length; i++) if (items[i].matches(sel)) return i; return -1; }
    var path = norm(location.pathname);
    var current = -1;
    items.forEach(function (it, i) { if (current < 0 && it.classList.contains('is-active')) current = i; });
    if (current < 0) {
      items.forEach(function (it, i) {
        if (current > -1) return;
        try { if (norm(new URL(it.getAttribute('href'), location.href).pathname) === path) current = i; } catch (e) {}
      });
    }
    if (current < 0) {
      if (/^\/(collections|products)(\/|$)/.test(path)) current = find('[data-asa-bnav-shop]');
      else if (/^\/search(\/|$)/.test(path)) current = find('[data-asa-bnav-search]');
      else if (/^\/cart(\/|$)/.test(path)) current = find('[data-asa-bnav-cart]');
    }
    if (current > -1) {
      items[current].classList.add('is-active');
      if (!items[current].hasAttribute('aria-current')) items[current].setAttribute('aria-current', 'page');
    }

    /* ----- geometry ----- */
    var rects = [], navLeft = 0, navTop = 0;
    function readRects() {
      var nr = nav.getBoundingClientRect();
      navLeft = nr.left;
      navTop = nr.top;
      rects = items.map(function (it) { var r = it.getBoundingClientRect(); return { l: r.left - nr.left, w: r.width }; });
    }
    function lensW(i) { var r = rects[i]; return r ? Math.max(40, Math.min(r.w - 4, 72)) : w; }
    function spot(i) { var r = rects[i]; return r ? r.l + (r.w - w) / 2 : x; }
    function nearest(cx) {
      var rx = cx - navLeft, best = 0, bd = Infinity;
      for (var i = 0; i < rects.length; i++) {
        var c2 = rects[i].l + rects[i].w / 2, dd = Math.abs(c2 - rx);
        if (dd < bd) { bd = dd; best = i; }
      }
      return best;
    }

    /* ----- spring state ----- */
    var x = 0, vx = 0, tx = 0;        /* position, speed (px/s), target */
    var k = 380, c = 21;               /* stiffness / damping of the position spring */
    var ps = 1, pv = 0, pt = 1;        /* press scale, its speed and target */
    var jelly = 0;                     /* smoothed stretch amount */
    var w = 64, raf = 0, last = 0, shown = false, lensIdx = -1;

    function paint(sx, sy) {
      lens.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)' +
        (sx === 1 && sy === 1 ? '' : ' scale(' + sx.toFixed(4) + ',' + sy.toFixed(4) + ')');
    }
    function frame(now) {
      raf = 0;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
      last = now;
      var n = Math.max(1, Math.ceil(dt * 240)), h = dt / n;
      for (var s = 0; s < n; s++) {
        vx += (k * (tx - x) - c * vx) * h;
        x += vx * h;
        pv += (560 * (pt - ps) - 24 * pv) * h;
        ps += pv * h;
      }
      var want = Math.min(0.4, Math.abs(vx) / 1400);
      jelly += (want - jelly) * Math.min(1, dt * 26);
      var sx = ps * (1 + jelly), sy = ps * (1 - jelly * 0.45);
      if (Math.abs(tx - x) < 0.05 && Math.abs(vx) < 0.6 && Math.abs(pt - ps) < 0.0015 && Math.abs(pv) < 0.02 && jelly < 0.0015) {
        x = tx; vx = 0; ps = pt; pv = 0; jelly = 0; last = 0;
        paint(ps, ps);
        return;
      }
      paint(sx, sy);
      raf = requestAnimationFrame(frame);
    }
    function kick() {
      if (reduce) { x = tx; vx = 0; ps = pt = 1; paint(1, 1); return; }
      if (!raf) { last = 0; raf = requestAnimationFrame(frame); }
    }
    function mark(i) {
      if (i === lensIdx) return;
      if (lensIdx > -1 && items[lensIdx]) items[lensIdx].classList.remove('is-lens');
      lensIdx = i;
      if (i > -1 && items[i]) items[i].classList.add('is-lens');
    }
    function show(on) {
      if (on === shown) return;
      shown = on;
      nav.classList.toggle('has-lens', on);
      if (!on) mark(-1);
    }
    function setW(nw) {
      if (Math.abs(nw - w) < 0.5) return;
      w = nw;
      lens.style.width = w + 'px';
    }
    function jump(i) {
      if (!rects.length) readRects();
      setW(lensW(i));
      x = tx = spot(i); vx = 0; ps = pt = 1; pv = 0; jelly = 0;
      paint(1, 1);
      mark(i);
      show(true);
    }
    function springTo(i, stiff, damp) {
      if (!rects.length) readRects();
      setW(lensW(i));
      tx = spot(i); k = stiff; c = damp;
      mark(i);
      show(true);
      kick();
    }
    function home() {
      if (current > -1) springTo(current, 380, 22);
      else { pt = 1; show(false); }
    }

    /* ----- first placement: continue the glide from the previous page, or sit still ----- */
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('asaLens') || 'null'); sessionStorage.removeItem('asaLens'); } catch (e) {}
    if (current > -1) {
      readRects();
      if (saved && !reduce && typeof saved.x === 'number' && Date.now() - saved.t < 4000) {
        setW(lensW(current));
        x = saved.x; vx = saved.v || 0;
        paint(1, 1);
        show(true);
        springTo(current, 380, 21);
      } else {
        jump(current);
      }
    }
    window.addEventListener('resize', function () { rects = []; readRects(); if (lensIdx > -1) jump(lensIdx); }, { passive: true });

    /* ----- finger / mouse -----
       Fingers use touch events: once a sideways drag starts, the page and the invisible iPhone haptic
       switches over the tabs (asa-sound) are told not to take the gesture, so the lens keeps following.
       A plain tap is left to the browser (so the iPhone switch gives its haptic tick); a drag decides the
       tab itself on release. Mouse / pen use pointer events. */
    var OPENERS = '[data-asa-bnav-shop], [data-asa-bnav-cart], [data-asa-bnav-search]';
    var isIOS = /iP(hone|od|ad)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var canVibrate = !isIOS && typeof navigator.vibrate === 'function';
    /* clearly stronger than the 38 ms tick of the other buttons */
    var BUZZ_TICK = 42, BUZZ_TAP = 65, BUZZ_DROP = [75, 45, 55];
    function buzz(p) { if (canVibrate) { try { navigator.vibrate(p); } catch (e) {} } }
    var pressed = false, dragging = false, sx0 = 0, sy0 = 0, overIdx = -1, tid = null, mid = null;
    function skipNativeClick() {
      nav.__asaSkipClick = true;
      clearTimeout(nav.__asaSkipT);
      nav.__asaSkipT = setTimeout(function () { nav.__asaSkipClick = false; }, 600);
    }
    function endPress() {
      pressed = false;
      dragging = false;
      if (mid !== null) { try { nav.releasePointerCapture(mid); } catch (e) {} }
      nav.classList.remove('is-pressing', 'is-dragging');
      pt = 1;
    }
    function cancel() {
      tid = null; mid = null;
      if (!pressed) return;
      endPress();
      home();
    }
    function toTop() {
      try { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    }
    function remember() {
      try { sessionStorage.setItem('asaLens', JSON.stringify({ x: x, v: vx, t: Date.now() })); } catch (e) {}
    }
    function activate(i) {
      var it = items[i];
      if (!it) return;
      if (i === current && !it.matches(OPENERS)) { toTop(); return; } /* the tab you are on: back to the top */
      setTimeout(function () {
        remember();
        nav.__asaOwnClick = true;
        try { it.click(); } finally { nav.__asaOwnClick = false; }
      }, reduce ? 0 : 110);
    }
    function press(cx, cy) {
      if (pressed) endPress(); /* a press that never ended (finger lost): start clean */
      readRects();
      pressed = true;
      dragging = false;
      sx0 = cx;
      sy0 = cy;
      nav.classList.add('is-pressing');
      pt = 1.12;
      overIdx = nearest(cx);
      springTo(overIdx, 520, 26);
    }
    /* returns true while the lens is being dragged */
    function move(cx, cy) {
      if (!pressed) return false;
      if (!dragging) {
        if (Math.abs(cx - sx0) < 6) {
          if (sy0 - cy > 70) cancel(); /* swiped up and away: let go */
          return false;
        }
        dragging = true;
        nav.classList.add('is-dragging');
      }
      var min = spot(0), max = spot(rects.length - 1);
      var raw = cx - navLeft - w / 2;
      if (raw < min) raw = min - (min - raw) * 0.3;
      else if (raw > max) raw = max + (raw - max) * 0.3;
      tx = raw; k = 4000; c = 100;
      show(true);
      var i = nearest(cx);
      if (i !== overIdx) { overIdx = i; mark(i); buzz(BUZZ_TICK); }
      kick();
      return true;
    }
    /* returns 'drag', 'tap' or '' */
    function finish(cx, cy) {
      if (!pressed) return '';
      var wasDrag = dragging;
      endPress();
      if (!wasDrag && cy < navTop - 70) { home(); return ''; }
      var i = nearest(cx);
      springTo(i, 380, 21);
      if (!wasDrag) return 'tap'; /* the browser's click opens the tab */
      skipNativeClick();
      buzz(BUZZ_DROP);
      activate(i);
      return 'drag';
    }

    function ourTouch(list) {
      for (var i = 0; i < list.length; i++) if (list[i].identifier === tid) return list[i];
      return null;
    }
    nav.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) { cancel(); return; }
      var t = e.changedTouches[0];
      tid = t.identifier;
      press(t.clientX, t.clientY);
    }, { passive: true });
    nav.addEventListener('touchmove', function (e) {
      var t = ourTouch(e.changedTouches);
      if (!t) return;
      if (move(t.clientX, t.clientY) && e.cancelable) e.preventDefault();
    }, { passive: false });
    nav.addEventListener('touchend', function (e) {
      var t = ourTouch(e.changedTouches);
      if (!t) return;
      tid = null;
      if (finish(t.clientX, t.clientY) === 'drag' && e.cancelable) e.preventDefault(); /* no click after a drag */
    });
    nav.addEventListener('touchcancel', function (e) { if (ourTouch(e.changedTouches)) cancel(); });

    nav.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button > 0) return;
      mid = e.pointerId;
      press(e.clientX, e.clientY);
    });
    nav.addEventListener('pointermove', function (e) {
      if (e.pointerId !== mid) return;
      var was = dragging;
      if (move(e.clientX, e.clientY) && !was) { try { nav.setPointerCapture(mid); } catch (err) {} }
    });
    function mouseUp(e) {
      if (mid === null || e.pointerId !== mid) return;
      finish(e.clientX, e.clientY);
      mid = null;
    }
    nav.addEventListener('pointerup', mouseUp);
    window.addEventListener('pointerup', mouseUp); /* released outside the bar */
    nav.addEventListener('pointercancel', function (e) { if (e.pointerId === mid) cancel(); });
    window.addEventListener('blur', cancel);

    nav.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.asa-hap')) return; /* iPhone haptic switch: let it toggle */
      if (nav.__asaOwnClick) return;
      if (nav.__asaSkipClick) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var it = e.target.closest && e.target.closest('.asa-bnav__item');
      if (it && items.indexOf(it) === current && !it.matches(OPENERS)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        buzz(BUZZ_TAP);
        toTop();
      }
    }, true);
    nav.addEventListener('click', function (e) {
      var it = e.target.closest && e.target.closest('.asa-bnav__item');
      if (!it || (e.target.closest && e.target.closest('.asa-hap'))) return;
      if (!nav.__asaOwnClick) {
        buzz(BUZZ_TAP); /* after the 38 ms tick of asa-sound, so the stronger one wins */
        if (!it.matches(OPENERS)) remember();
      }
    });

    /* sheets / drawers opened from the bar keep the lens on their tab; when they close, it glides back */
    document.addEventListener('close', function (e) {
      if (!e.target || e.target.tagName !== 'DIALOG') return;
      setTimeout(function () { if (!pressed) home(); }, 80);
    }, true);
    /* coming back with the browser's back button (page restored from cache): reset */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      tid = null; mid = null;
      endPress();
      cancelAnimationFrame(raf); raf = 0;
      rects = [];
      try { sessionStorage.removeItem('asaLens'); } catch (err) {}
      if (current > -1) { readRects(); jump(current); } else show(false);
    });
  }


  /* ---------- 3. phone back gesture / back button closes an open menu or sheet first ----------
     Opening the menu, the shop sheet, search or quick view adds one step to the browser history.
     Swiping back (or the back button) then closes that window instead of leaving the page.
     A link tapped inside an open window replaces that step, so history stays clean.
     The filter drawer is left alone (filters keep their own history). */
  (function () {
    var stack = [];
    var ignorePop = 0;
    var SEL = 'header-drawer details, details.menu-drawer-container, dialog';
    function managed(el) {
      if (!el.matches || !el.matches(SEL)) return false;
      if (el.closest('.facets, .facets--drawer, [class*="facets"]')) return false;
      return true;
    }
    function isOpen(el) { return el.hasAttribute('open'); }
    function closeEl(el) {
      var btn = el.querySelector(':scope [data-asa-shop-close], :scope .menu-drawer__close-button, :scope .close-button, :scope [class*="__close"]');
      if (btn) btn.click();
      else if (el.tagName === 'DIALOG' && el.close) el.close();
      else el.removeAttribute('open');
    }
    function onOpen(el) {
      if (stack.indexOf(el) > -1) return;
      stack.push(el);
      try { history.pushState({ asaOverlay: stack.length }, ''); } catch (e) {}
    }
    function onClose(el) {
      var i = stack.indexOf(el);
      if (i < 0) return;
      stack.splice(i, 1);
      if (history.state && history.state.asaOverlay) { ignorePop++; history.back(); }
    }
    window.addEventListener('popstate', function () {
      if (ignorePop) { ignorePop--; return; }
      var el = stack.pop();
      if (el && isOpen(el)) closeEl(el);
    });
    /* a normal link inside an open window: go there and replace the extra history step */
    document.addEventListener('click', function (e) {
      if (!stack.length || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target || a.hasAttribute('download') || a.origin !== location.origin) return;
      if (!stack.some(function (el) { return el.contains(a); })) return;
      if (a.pathname === location.pathname && a.search === location.search && a.hash) return;
      if (!(history.state && history.state.asaOverlay)) return;
      e.preventDefault();
      location.replace(a.href);
    });
    new MutationObserver(function (muts) {
      for (var k = 0; k < muts.length; k++) {
        var el = muts[k].target;
        if (!managed(el)) continue;
        if (isOpen(el)) onOpen(el); else onClose(el);
      }
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    /* page restored from the back/forward cache: forget windows that are no longer open */
    window.addEventListener('pageshow', function (e) { if (e.persisted) stack = stack.filter(isOpen); });
  })();

  function start() { initLens(document.querySelector('.asa-bnav')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
